import React from 'react';
import { isImageFile, getFileIcon, API_BASE } from '../utils/fileUtils';

interface TaskFileListProps {
  filenames: string[];
  folder: string;
  onOpen: (index: number) => void;
  onDownload: (filename: string) => void;
}

const TaskFileList: React.FC<TaskFileListProps> = ({ filenames, folder, onOpen, onDownload }) => {
  if (filenames.length === 0) return null;
  return (
    <div style={{ display: 'grid', gap: '0.75rem' }}>
      {filenames.map((filename, index) => (
        <div
          key={index}
          className="notification-file-card"
          style={{ display: 'flex', alignItems: 'center', padding: '0.875rem', gap: '1rem', cursor: 'pointer' }}
          onClick={() => onOpen(index)}
        >
          <div style={{ width: 56, height: 56, flexShrink: 0, borderRadius: 8, overflow: 'hidden', background: 'var(--bg-tertiary)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isImageFile(filename) ? (
              <img
                src={`${API_BASE}/uploads/${folder}/${filename}`}
                alt={filename}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <span style={{ fontSize: '1.75rem' }}>{getFileIcon(filename)}</span>
            )}
          </div>
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <div className="notification-file-name">{filename}</div>
          </div>
          <button
            className="btn btn-primary btn-sm"
            onClick={(e) => { e.stopPropagation(); onDownload(filename); }}
          >
            Скачать
          </button>
        </div>
      ))}
    </div>
  );
};

export default TaskFileList;
